import React from 'react';
import { useGetDefaultLocationRequestConfigQuery, useUpdateDefaultLocationRequestConfigMutation } from '../../api/locationRequestConfigsApiSlice';
import Block from '../Block';
import { Loader } from '../components';
import LocationRequestConfigForm from './LocationRequestConfigForm';

const LocationRequestConfigDefault = () => {
  const {data: location_request_config, isSuccess, isLoading} = useGetDefaultLocationRequestConfigQuery()
  const [update] = useUpdateDefaultLocationRequestConfigMutation()

  if (!isSuccess) {
    return (<></>)
  }

  return (
    <Block>
      <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess}>
        <LocationRequestConfigForm
          locations_request_config={location_request_config}
          onSave={update}
          />
      </Loader>
    </Block>
  );
}

export default LocationRequestConfigDefault;